
    import './styles.scoped.css';
    export default {
  "background-fill": "awsui_background-fill_1fi2u_1a6be_1",
  "content": "awsui_content_1fi2u_1a6be_6"
};
  